export const stringByStatusMovimiento = (val) => {
    switch (val) {
        case 0:
            return "Pendiente de proformas"
        default:
            return "Pendiente de proformas"
    }
}